export const TableData = [
  {
    id: '01',
    header: 'Environmental Stewardship',
    body: "Environmental stewardship is more than just a concept,it's a call to action. Our projects are designed to empower individuals and organizations to take concrete steps towards a more sustainable future. ",
  },
  {
	id: '02',
    header: 'Collaboration',
    body: 'We foster a culture of partnership and teamwork, working closely with individuals, organizations, and businesses to create a more sustainable future.',
  },
  {
    id: '03',
	header: 'Hands-on Learning',
    body: 'We prioritise hands-on learning and practical experience as essential for empowering individuals to transition to sustainability careers while driving sustainable change.',
  },
];
